// Pure helpers for the admin Growth tab (components/GrowthTab.jsx).

export const DRAFT_FILTERS = [
  { value: 'review', label: 'To review' },
  { value: 'approved', label: 'Approved' },
  { value: 'posted', label: 'Posted' },
  { value: 'denied', label: 'Denied' },
  { value: 'all', label: 'All' },
];

const IN_FILTER = {
  review: (d) => d.status === 'ready' || d.status === 'flagged',
  approved: (d) => d.status === 'approved',
  posted: (d) => d.status === 'posted',
  denied: (d) => d.status === 'denied' || d.status === 'replaced',
  all: () => true,
};

export function filterDrafts(drafts = [], filter = 'review') {
  const fn = IN_FILTER[filter] || IN_FILTER.all;
  // Ready before flagged, then newest.
  return drafts.filter(fn).sort((a, b) => (a.status === 'flagged') - (b.status === 'flagged') || String(b.createdAt).localeCompare(String(a.createdAt)));
}

export function draftCounts(drafts = []) {
  const c = { review: 0, approved: 0, posted: 0, denied: 0, all: drafts.length };
  for (const d of drafts) for (const k of ['review', 'approved', 'posted', 'denied']) if (IN_FILTER[k](d)) c[k] += 1;
  return c;
}

/** Only https links are ever opened (lead URLs come from scraped feeds). */
export function safeUrl(url) {
  const s = String(url || '').trim();
  return /^https:\/\/[^\s]+$/i.test(s) ? s : null;
}

/** Where "Approve" sends the admin: the thread for a reply, a prefilled composer for a post. */
export function composerUrl(draft) {
  if (!draft) return null;
  if (draft.kind === 'reply') return safeUrl(draft.leadUrl);
  const text = encodeURIComponent(draft.body || '');
  if (draft.platform === 'x') return `https://x.com/intent/post?text=${text}`;
  if (draft.platform === 'bluesky') return `https://bsky.app/intent/compose?text=${text}`;
  return null;
}

export const PLATFORM_LABEL = { reddit: 'Reddit', bluesky: 'Bluesky', x: 'X', discord: 'Discord', forum: 'Forum' };

export function communityLabel(d) {
  if (!d) return '';
  if (d.kind === 'post' || d.community === 'post') return `${PLATFORM_LABEL[d.platform] || d.platform} post`;
  if (d.platform === 'reddit') return `r/${d.community}`;
  return `${PLATFORM_LABEL[d.platform] || d.platform}${d.community && d.community !== d.platform && d.community !== 'search' ? ` · ${d.community}` : ''}`;
}

export const DATA_MODE_COPY = {
  live: null,
  sandbox: 'Prices are sandbox (test key). Data posts are labelled sample data and never quoted as current odds.',
  frozen: 'Freeze mode: data posts use the archived snapshot and are labelled sample data.',
  stale: 'Best-bets cache is over a day old. Data posts are labelled sample data.',
};

/** Banner lines for the sources pill row: [{ name, state, text }]. */
export function sourceRows(sources) {
  if (!sources) return [];
  return ['reddit', 'bluesky'].filter((k) => sources[k]).map((k) => {
    const s = sources[k];
    const text = s.state === 'ok' ? `${s.items} items` : s.state === 'blocked' ? 'blocked from the cloud; add Reddit threads by hand' : (s.errors || [])[0] || 'failing';
    return { name: k, state: s.state, text, lastOkAt: s.lastOkAt || null };
  });
}

export const GOAL_TONE = { done: 'good', ahead: 'good', 'on-pace': undefined, behind: 'warn' };

export function money(n) {
  const v = Number(n) || 0;
  return `$${v < 1 ? v.toFixed(3) : v.toFixed(2)}`;
}
